/* eslint-disable vue/no-unused-vars */
<template>
  <div class="main">
  <!-- Left -->
    <div class="main_l">
      <!-- 组织架构 -->
      <Organization @change="changeOrganization"></Organization>
    </div>
    <!-- Left End -->

    <!-- Right -->
    <div class="main_r">
      <div class="title">项目列表</div>

      <!-- search -->
      <div class="search">
        <div>
          <el-input v-model="keyword"  placeholder="请输入名称"></el-input>
          <el-button type="primary" @click="clickQuery">查询</el-button>
          <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
        </div>
        <el-button type="primary" @click="clickAdd">新增</el-button>
      </div>
      <!-- search End -->

      <!-- 列表 -->
      <el-table :data="dataList" ref="projecttable" style="width: 100%" class="tableOut" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
        <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
        <el-table-column prop="organizationName" label="项目名称" sortable="custom"></el-table-column>
        <el-table-column prop="organizationAddress" label="地址" sortable="custom"></el-table-column>
        <el-table-column prop="organizationInfo" label="简介" width="100" sortable="custom"></el-table-column>
        <el-table-column prop="organizationNote" label="备注" sortable="custom"></el-table-column>

        <el-table-column prop="Operation" label="操作" width="100">
          <template v-slot="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
              <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickEdit(scope.row)"></el-link>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
              <el-link :underline="false" type="danger" icon="el-icon-delete" @click="clickDel(scope.row)"></el-link>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="mt20">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="10"
          layout="prev, pager, next, sizes, jumper "
          :total="dataListnum">
        </el-pagination>
      </div>
      <!-- 分页 End -->
    </div>
    <!-- Right End -->

    <!---------------------- 以下是一级Table弹框内容 ---------------------->
    <!-- 新增项目 -->
    <el-dialog title="新增项目" :visible.sync="dialogAddProject" class="newAdd" :close-on-click-modal="false">
      <el-row :gutter="24" class="add_project">
        <!-- left -->
        <el-col :xl="9">
          <el-form :model="addForm">
            <el-form-item label="名称" :label-width="formLabelWidth" :required=true>
              <el-input v-model="addForm.organizationName" autocomplete="off" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="地址" :label-width="formLabelWidth">
              <el-input v-model="addForm.organizationAddress" autocomplete="off" placeholder="请输入地址"></el-input>
            </el-form-item>
            <el-form-item label="简介" :label-width="formLabelWidth">
              <el-input v-model="addForm.organizationInfo" autocomplete="off" placeholder="请输入简介"></el-input>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth">
              <el-input v-model="addForm.organizationNote" autocomplete="off" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrganization()">确 认</el-button>
        <el-button @click="dialogAddProject = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 添加项目 End -->

    <!-- 编辑信息 -->
    <el-dialog title="编辑信息" :visible.sync="dialogEditProject" class="newAdd" :close-on-click-modal="false">
      <el-row :gutter="24" class="add_project">
        <!-- left -->
        <el-col :xl="9">
          <el-form :model="editForm">
            <el-form-item label="名称" :label-width="formLabelWidth" :required=true>
              <el-input v-model="editForm.organizationName" autocomplete="off" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="地址" :label-width="formLabelWidth">
              <el-input v-model="editForm.organizationAddress" autocomplete="off" placeholder="请输入地址"></el-input>
            </el-form-item>
            <el-form-item label="简介" :label-width="formLabelWidth">
              <el-input v-model="editForm.organizationInfo" autocomplete="off" placeholder="请输入简介"></el-input>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth">
              <el-input v-model="editForm.organizationNote" autocomplete="off" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editOrganization()" >确 认</el-button>
        <el-button @click="dialogEditProject = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑信息 End -->

    <!-- 删除 -->
    <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
      <div class="confirmMsg">确定删除？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteOrganization" >确 定</el-button>
        <el-button @click="dialogDel = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 删除 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import Organization from '@/components/Organization.vue'
Vue.use(VueAxios, axios)

export default {
  components: { Organization },
  data () {
    return {
      formLabelWidth: '120px',
      selectParentId: '',
      keyword: '',
      dataList: [],
      dataListnum: 0,
      pageNo: 1,
      pageSize: 10,
      sortField: '',
      sortOrder: '',
      addForm: {
        parentId: '',
        organizationName: '',
        organizationType: '',
        organizationAddress: '',
        organizationInfo: '',
        organizationNote: ''
      },
      editForm: {
        id: '',
        organizationName: '',
        organizationAddress: '',
        organizationInfo: '',
        organizationNote: ''
      },
      deleteForm: {
        id: ''
      },
      currentPage: 0,

      dialogAddProject: false,
      dialogEditProject: false,
      dialogDel: false
    }
  },
  mounted () {
  },
  methods: {
    changeOrganization (node) {
      this.addForm.parentId = node.id
      this.selectParentId = node.id
      this.listProject()
      this.numProject()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.listProject()
      this.numProject()
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.listProject()
      this.numProject()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.pageNo = 1
      this.listProject()
      this.numProject()
    },
    clickQuery () {
      this.listProject()
      this.numProject()
    },
    clickQueryReset () {
      this.keyword = ''
      this.listProject()
      this.numProject()
    },
    clickAdd () {
      this.dialogAddProject = true
      this.addForm.organizationName = ''
      this.addForm.organizationType = '1'
      this.addForm.organizationAddress = ''
      this.addForm.organizationInfo = ''
      this.addForm.organizationNote = ''
    },
    clickEdit (row) {
      this.dialogEditProject = true
      this.editForm.id = row.id
      this.editForm.organizationName = row.organizationName
      this.editForm.organizationAddress = row.organizationAddress
      this.editForm.organizationInfo = row.organizationInfo
      this.editForm.organizationNote = row.organizationNote
    },
    clickDel (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    listProject: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.selectParentId
      data.keyword = that.keyword
      data.pageNo = that.pageNo
      data.pageSize = that.pageSize
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_listProject, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    numProject: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.selectParentId
      data.keyword = that.keyword
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_numProject, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    addOrganization: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.addForm.parentId
      data.organizationName = that.addForm.organizationName
      data.organizationType = that.addForm.organizationType
      data.organizationAddress = that.addForm.organizationAddress
      data.organizationInfo = that.addForm.organizationInfo
      data.organizationNote = that.addForm.organizationNote
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_addOrganization, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dialogAddProject = false
            that.listProject()
            that.numProject()
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.FunRemindAllways('添加出错')
        })
    },
    editOrganization: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editForm.id
      data.organizationName = that.editForm.organizationName
      data.organizationAddress = that.editForm.organizationAddress
      data.organizationInfo = that.editForm.organizationInfo
      data.organizationNote = that.editForm.organizationNote
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_editOrganization, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dialogEditProject = false
            that.listProject()
            that.numProject()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    deleteOrganization: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_deleteOrganization, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dialogDel = false
            that.listProject()
            that.numProject()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.main .main_l{
  width: 380px;
  flex-shrink: 0;
  border-right: 1px solid #e6e6e6;
}
.search {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }

}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 200px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 110px;
    }
  }
}

// 表格头部背景色
/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

/deep/ .el-table__expand-icon {
  display: none;
}

.el-form-item {
  margin-bottom: 16px;
}

.organization_code{
  width: 127px;
  margin-right: 12px;
}

// 新增组织架构
.add_organization{
  padding-right: 15px;

  .organization_code{
    width: 157px;
    margin-right: 12px;
  }
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;

      & em{
        font-style: normal;
        color: #4976ff;
      }
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.sgdInfo{
  padding-left: 20px;
}

.tableOut{
  margin-top: 15px;

  // 圆角处理
  /deep/ thead tr th:nth-child(1) {
    border-radius: 10px 0 0 0;
  }
  /deep/ thead tr th:nth-last-child(2) {
    border-radius: 0 10px 0 0;
  }
}

// 内表格
.tableInner{
  margin-top: 20px;

  ::-webkit-scrollbar{
    width: 6px;  /*滚动条宽度*/
    height: 6px;  /*滚动条高度*/
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb{
    border-radius: 3px;
    background-color: #4976ff;  /*滚动条的背景颜色*/
  }

  // 圆角处理
  /deep/ thead tr th:nth-child(1) {
    border-radius: 10px 0 0 0;
  }
  /deep/ thead tr th:last-child {
    border-radius: 0 10px 0 0;
  }
}

.addUser_body{
  padding: 15px 40px 0 30px;
}

/deep/ .el-table__expanded-cell {
  padding: 20px 0px 0px 0px;
  margin: 15px;
  border: 1px solid #4976ff;
  border-radius: 10px;
  overflow: hidden;
}

.position{
  overflow: hidden;
  height: 433px;
  background: #f7f7f7;
}

// 弹出框
/deep/ .el-dialog__body {
  padding: 20px;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  background: #f6f6fa;
}

.confirmDel /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.confirmDel /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.confirmDel /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.confirmMsg{
  padding: 10px 0 10px 0;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  & em{
    font-style: normal;
    margin-right: 10px;
    padding: 2px 6px;
    background: #f6f6fa;
    border-radius: 4px;
  }
}

.tree_txt{
  padding: 2px 6px;
  margin-right: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.tree_btn{
  margin-right: 5px;
}

.blue{
  color: #4976ff;
}

/deep/ .el-tree-node__content {
  height: 36px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}
/deep/ .el-tree-node__expand-icon {
    color: #4976ff;
  }
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #4976ff;
  background-color: #fff;
}
/deep/ .el-tree-node__content:hover {
  color: #4976ff;
  background-color: #fff;
}

// /deep/ .custom-tree-node {
//   padding-right: 0px;
// }

// 组织架构
/deep/ .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 8px;
}

.tree_add_btn{
  margin-right: 5px;
}
</style>
